import styled from "@emotion/styled/macro";
import { css } from "@emotion/react";
import { tokens } from "@sunrun/experience-ui-components";
import { mobileMaxWidth } from "components/atoms/GlobalStyles";

const checkoutFooterButtonHeight = 48;
const checkoutFooterPaddingDesktop = 36; // 12px top + 24px bottom
const checkoutFooterPaddingMobile = 48; // 24px top + 24px bottom

const CheckoutHeaderGrid = styled.div`
  grid-area: header;

  & > :not(:only-child):first-child {
    margin-bottom: 48px;
  }

  & > :not(:first-child):not(:last-child) {
    margin-bottom: 20px;
  }
`;

const CheckoutSidebarGrid = styled.div`
  grid-area: sidebar;
`;

const CheckoutContentGrid = styled.div`
  grid-area: content;
`;

const CheckoutFullWidthContentGrid = styled.div<{ isMobile?: boolean }>`
  grid-row-start: sidebar;
  grid-row-end: sidebar;
  grid-column-start: sidebar;
  grid-column-end: content;
  border-top: ${(props) =>
    props.isMobile ? "0px" : `1px solid ${tokens.TINTS_HERO_BLUE_80}`};
`;

const CheckoutFooterGrid = styled.div<{ isMobile?: boolean }>`
  grid-area: footer;
  position: sticky;
  bottom: 0;
  z-index: 10;
  background: ${tokens.BACKGROUND_LIGHT};
  border-top: 1px solid ${tokens.TINTS_OFF_WHITE_40};
  margin-left: ${({ isMobile }) => (isMobile ? "-16px" : "-64px")};
  margin-right: ${({ isMobile }) => (isMobile ? "-16px" : "-64px")};
  padding: 12px ${({ isMobile }) => (isMobile ? "16px" : "64px")} 24px;
  box-sizing: border-box;
  min-width: 0;
  min-height: ${({ isMobile }) =>
    isMobile
      ? checkoutFooterPaddingMobile + checkoutFooterButtonHeight
      : checkoutFooterPaddingDesktop + checkoutFooterButtonHeight}px;

  @media (max-width: ${mobileMaxWidth}px) {
    padding-top: 24px;
    padding-bottom: 24px;
    min-height: ${checkoutFooterPaddingMobile + checkoutFooterButtonHeight}px;
  }
`;

const CheckoutBackground = css`
  background: linear-gradient(
    180deg,
    ${tokens.CHARGEBLUE_50} 0,
    ${tokens.BACKGROUND_LIGHT} 16rem
  );
`;

const CheckoutGrid = styled.div<{ isMobile?: boolean }>`
  min-height: 100vh;
  box-sizing: border-box;
  ${CheckoutBackground};
  display: grid;
  row-gap: ${(props) => (props.isMobile ? "24px" : "38px")};
  column-gap: 25px;
  grid-template-columns: ${(props) =>
    props.isMobile ? "repeat(auto-fit, minmax(342px, 1fr));" : "230px 1fr"};
  grid-template-rows: ${(props) =>
    props.isMobile ? "auto 168px 1fr auto" : "auto 1fr auto"};
  grid-template-areas: ${(props) =>
    props.isMobile
      ? '"header" "sidebar" "content" "footer"'
      : '"header header" "sidebar content" "footer footer"'};
  padding: ${(props) => (props.isMobile ? "24px 16px 0" : "62px 64px 0")};
`;

export {
  CheckoutGrid,
  CheckoutHeaderGrid,
  CheckoutSidebarGrid,
  CheckoutContentGrid,
  CheckoutFooterGrid,
  CheckoutFullWidthContentGrid,
  CheckoutBackground,
};
